/*************************************************/
/* EMPLOYEES                                     */
/*************************************************/
export function employees() {
    const offSetClass = "employee-item--offset";

    const init = () => {

        document.querySelectorAll(".employee-items__with-image").forEach(function (list) {
            const items = list.querySelectorAll(".employee-item");
            const itemsPerColumn = Math.ceil(items.length / 2); // 2 columns per list
            
            // Remove offset class from all items first (in case of re-render)
            items.forEach(item => item.classList.remove(offSetClass));

            // Add offset to the first item in the second column (if it exists)
            if (items.length > itemsPerColumn) {
                items[itemsPerColumn].classList.add(offSetClass);
            }
        });
    };

    init();

}